import { render, staticRenderFns } from "./FollowupsPatientCell.vue?vue&type=template&id=083dd7e2&scoped=true"
import script from "./FollowupsPatientCell.vue?vue&type=script&lang=js"
export * from "./FollowupsPatientCell.vue?vue&type=script&lang=js"
import style0 from "./FollowupsPatientCell.vue?vue&type=style&index=0&id=083dd7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083dd7e2",
  null
  
)

export default component.exports